module.exports = __webpack_public_path__ + "public/img/upload.b3fc40f9.png";